import { defineStore } from 'pinia';

const useOtjModalStore = defineStore('otjModal', {
  state: () => ({
    otjModal: {
      isOpen: false,
      programmeId: null,
      isEditing: false,
      otjData: null,
      programmeMemberId: null,
    },
  }),

  getters: {
    isOtjModalOpen: state => state.otjModal.isOpen,
    otjModalData: state => state.otjModal,
  },

  actions: {
    // Open OTJ modal for adding new entry
    openOtjModal(programmeId, options = {}) {
      this.otjModal = {
        isOpen: true,
        programmeId,
        isEditing: false,
        otjData: null,
        programmeMemberId: options.programmeMemberId || null,
      };
    },

    // Open OTJ modal for editing existing entry
    openOtjEditModal(programmeId, otjData, options = {}) {
      this.otjModal = {
        isOpen: true,
        programmeId,
        isEditing: true,
        otjData,
        programmeMemberId: options.programmeMemberId || null,
      };
    },

    closeOtjModal() {
      this.otjModal.isOpen = false;
    },

    resetOtjModal() {
      this.otjModal = {
        isOpen: false,
        programmeId: null,
        isEditing: false,
        otjData: null,
        programmeMemberId: null,
      };
    },
  },
});

export default useOtjModalStore;
